<template>
  <main id="mainCtrl">
    <div class="promo-settings">
      <div class="promo-settings__data">
        <div class="promo-settings__title">Онлайн-запись на прием</div>
        <div class="promo-settings__markers">
          <div v-if="integration_type === 'INDIVIDUAL'" class="promo-settings__marker promo-settings__marker_green">
            Подключено
          </div>
          <div v-else class="promo-settings__marker promo-settings__marker_red">Отключено</div>
        </div>
        <div class="promo-settings__text">
          <p>
            Включите интеграцию с сервисом МедФлекс, чтобы
            <wbr/>
            пациенты записывались на прием онлайн через наш сайт.
          </p>
          <ol>
            <li>Откройте "Магазин интеграций" на&nbsp;<a class="promo-settings__link"
                href="https://medflex.ru/cabinet/integrations/">сайте МедФлекс</a></li>
            <li>Сгенерируйте ключ доступа по&nbsp;<a class="promo-settings__link"
                href="https://help.medflex.ru/integraciya-cherez-api-so-storonnimi-servisami/">инструкции</a></li>
            <li>Вставьте полученный ключ доступа в поле для ввода ниже</li>
          </ol>

          <div class="field field-text" :class="{error :errorText.length}">
            <label>Ключ доступа МедФлекс</label>
            <div class="field-text__wrap">
              <input
                  type="text"
                  placeholder="Вставьте сгенерированный ключ доступа"
                  :disabled="integration_type === 'INDIVIDUAL'"
                  v-model="api_token"
              />
              <div class="field-text__wrap_clear" @click.prevent="api_token=''">
                <img src="/img/clear_12x12.svg" alt=""/>
              </div>
            </div>
            <div v-if="errorText" class="error">{{ errorText }}</div>
          </div>
        </div>
        <div class="promo-settings__actions">
          <a v-if="integration_type === 'INDIVIDUAL'"  @click.prevent="turnOffIntegration" href="#" class="promo-settings__btn promo-settings__btn-red">Отключить</a>
          <a v-else @click.prevent="turnOnIntegration" href="#" class="promo-settings__btn">Подключить</a>
        </div>
      </div>
      <div class="promo-settings__img">
        <img src="/img/online01.svg" alt=""/>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  props: ['api_token_init', 'integration_type_init'],
  data() {
    return {
      api_token: this.api_token_init === 'null' ? '' : this.api_token_init,
      integration_type: this.integration_type_init,
      errorText: ''
    }
  },
  watch: {
    'api_token'() {
      this.errorText = '';
    },
  },
  methods: {
    turnOffIntegration() {
      this.axios.post('settings/turnOffIndividualIntegration').then(() => {
        this.integration_type = 'LEAD';
      })
    },
    turnOnIntegration() {
      if (this.api_token.length < 10) {
        this.errorText = 'Введен неверный ключ доступа';
        return;
      }
      this.axios.post('settings/turnOnIndividualIntegration', {
        api_token: this.api_token,
      }).then((resp) => {
        this.integration_type = 'INDIVIDUAL';
      }).catch((err) => {
        this.errorText = err.message;
      });
    }
  },
}

</script>

<style scoped>
*,
*::before,
*::after {
  box-sizing: border-box;
  outline: none;
  margin: 0;
}

ul,
ol {
  padding: 0 0 0 0px;
}

.promo-settings {
  padding: 50px 70px;
  display: flex;
  gap: 0 140px;
  /* align-items: center; */
  font-family: "Open Sans", sans-serif;
  font-size: 20px;
  line-height: 30px;
}

.promo-settings__img {
  width: 332px;
  max-width: 100%;
  padding-top: 106px;
}

.promo-settings__data {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 700px;
  flex: 1 1 auto;
}

.promo-settings__title {
  color: #272727;
  font-size: 40px;
  line-height: 100%;
  font-weight: bold;
}

.promo-settings__text {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.promo-settings__text p {
  max-width: 580px;
}

.promo-settings ol {
  display: flex;
  flex-direction: column;
  gap: 0px;
  counter-reset: item;
  margin-bottom: 16px;
}

.promo-settings li {
  list-style-type: none;
  position: relative;
  padding-left: 0;
}

.promo-settings li::before {
  color: #13a546;
  font-weight: 600;
  display: inline-block;
  min-width: 27px;
  content: counter(item) ". ";
  counter-increment: item;
}

.promo-settings__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 50px;
  row-gap: 25px;
  align-items: center;
  margin-top: 16px;
}

.promo-settings__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #13a546;
  color: #fff;
  text-decoration: none;
  height: 54px;
  border-radius: 5px;
  border-bottom: none !important;
  padding: 10px 50px 14px;
  transition: 0.5s ease;
  min-width: 254px;
}

.promo-settings__btn:hover {
  background-color: #0a8036;
  color: #fff;
}

.promo-settings__btn-red {
  background-color: #dc4c39;
}

.promo-settings__btn-red:hover {
  background-color: #c51c1c;
}

.promo-settings__link {
  color: #2c2b67;
  text-decoration: none;
  font-weight: 600;
  border-bottom: none;
  /* border-bottom: 2px dotted #2c2b67; */
  line-height: 30px;
  transition: 0.5s ease;
}

.promo-settings__link:hover {
  color: #13a546;
  /* border-bottom: 2px dotted #13a546; */
}

.promo-settings__akcent-label {
  color: #13a546;
  font-weight: 600;
}

.promo-settings__markers {
  grid-area: markers;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.promo-settings__marker {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 14px 8px;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 600;
  line-height: 120%;
}

.promo-settings__marker_red {
  background: #ffe0e0;
  color: #eb5757;
}

.promo-settings__marker_green {
  background: #f2fdf1;
  color: #13a546;
}

.field-text label {
  display: block;
  font-weight: 600;
  margin-bottom: 8px !important;
  color: black;
  font-size: 14px;
  line-height: 1.2;
}

.field-text__wrap {
  position: relative;
}

.field-text__wrap input {
  height: 54px;
  font-size: 20px;
  background: #ffffff;
  border: 1px solid #ddd9ea !important;
  border-radius: 4px;
  padding: 14.5px 38px 15.5px 16px;
  line-height: 1.2;
  color: #000;
  width: 100%;
  background-clip: padding-box;
  text-overflow: ellipsis;
  font-family: "Open Sans", sans-serif;
}

.field-text__wrap input::placeholder {
  color: #9896ae;
}

.field-text__wrap input:disabled {
  padding-right: 16px;
  background-color: #f7f7fa;
  border-color: #ddd9ea !important;
  color: #9896ae;
}

.field-text__wrap input:disabled ~ .field-text__wrap_clear {
  display: none;
}

.field-text__wrap input:placeholder-shown + .field-text__wrap_clear {
  display: none;
}

.field-text__wrap_clear {
  cursor: pointer;
  position: absolute;
  right: 16px;
  top: 20.5px;
  width: 12px;
  height: 12px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.field-text__wrap_clear img {
  width: 100%;
  height: 100%;
  display: block;
}

.field-text.error .field-text__wrap input {
  border: 1px solid #eb5757 !important;
}

.field-text .error {
  display: none;
}

.field-text.error .error {
  display: block;
  line-height: 120%;
  color: #eb5757;
  margin-top: 8px;
  font-size: 14px;
}

@media (max-width: 991px) {
  .promo-settings {
    flex-wrap: wrap;
  }
}

@media (max-width: 600px) {
  .promo-settings {
    padding: 30px 30px;
    font-size: 20px;
    line-height: 25px;
  }

  .promo-settings__title {
    font-size: 33px;
  }

  .promo-settings li {
    padding-left: 20px;
  }

  .promo-settings li::before {
    top: 10px;
    height: 8px;
    width: 8px;
  }
}
</style>
